import { useSyncExternalStore } from "react"

// Short notices in the corner ("Order placed", "Couldn't cancel"). A plain
// store: anything may post; <Toasts /> renders them.

export type ToastTone = "ok" | "error" | "info"

export interface Toast {
  readonly id: number
  readonly tone: ToastTone
  readonly title: string
  readonly detail?: string | undefined
}

const MAX_SHOWN = 4

let toasts: ReadonlyArray<Toast> = []
let nextId = 1
const listeners = new Set<() => void>()

const set = (next: ReadonlyArray<Toast>) => {
  toasts = next
  for (const listener of listeners) listener()
}

export const dismissToast = (id: number): void => set(toasts.filter((toast) => toast.id !== id))

/** Shows a notice for a few seconds (errors stay longer). */
export const toast = (tone: ToastTone, title: string, detail?: string): void => {
  const id = nextId++
  set([...toasts, { id, tone, title, detail }].slice(-MAX_SHOWN))
  setTimeout(() => dismissToast(id), tone === "error" ? 9_000 : 4_500)
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export const useToasts = (): ReadonlyArray<Toast> => useSyncExternalStore(subscribe, () => toasts)
